module.exports = __webpack_public_path__ + "img/list_img3.3f0fb922.png";